import { Component, HostListener, OnInit } from '@angular/core';
import { Feeder11Service } from '../../services/feeder11.service';
import { Feeder33Service } from '../../services/feeder33.service';
import { Feeder11Dto } from '../../models/feeder11.model';
import { Feeder33Dto } from '../../models/feeder33.model';
import { AIImageUploadService } from '../../services/ai-image-upload.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { forkJoin, Observable } from 'rxjs';
import { AiUploadHistoryService } from '../../services/ai-upload-history.service';
import { AiUploadHistory } from '../../models/ai-upload-history.model';
import { UtilitySharedService } from '../../services/shared/utility-shared.service';

@Component({
  selector: 'lib-batch-image-import',
  templateUrl: './batch-image-import.component.html',
  styleUrls: ['./batch-image-import.component.scss'],
  standalone: false,
})
export class BatchImageImportComponent implements OnInit {

  showModal: boolean = false;
  selectedVoltage: string = '';
  selectedFeederId: number = 0;
  isSelectVoltageOpen = false;
  isSelectFeederOpen = false;
  selectedFeeders: Feeder11Dto[] | Feeder33Dto[] = [];
  filteredFeeders: Feeder11Dto[] | Feeder33Dto[] = [];
  feeders11: Feeder11Dto[] = [];
  feeders33: Feeder33Dto[] = [];
  searchText: string = '';
  selectedFiles: File[] = [];
  uploading = false;
  private sasToken: string = '';
  private folderName: string = '';
  guid: string = '';
  maxCount = 0;
  uploadedCount = 0;
  histories: AiUploadHistory[] = [];
  count: number = 0;
  pageSize = 10;
  currentPage: number = 1;
  url: string = 'https://droneimagescaims.blob.core.windows.net';
  constructor(
    private f11Service: Feeder11Service,
    private f33Service: Feeder33Service,
    private azureBlobService: AIImageUploadService,
    private toastr: ToastrService,
    private authService: AuthService,
    private aiHistoryUploadService: AiUploadHistoryService,
    private utilitySharedService: UtilitySharedService
  ) {}
  ngOnInit(): void {
    this.guid = crypto.randomUUID();
    this.getSasToken();
    this.reloadTable();
  }
  selectFeeder(id: number) {
    this.selectedFeederId = id;
  }
  reloadTable(page: number | null = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {},
    };
    this.getAll(obj);
  }
  private getAll(obj: any) {
    this.aiHistoryUploadService.getAll(obj).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.histories = responseData?.data?.data?.length
            ? responseData?.data?.data?.map(
                (el: any) => new AiUploadHistory(el)
              )
            : [];

          this.count = responseData.data.count ?? this.count;
          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }
  processBatch(obj: any) {
    this.aiHistoryUploadService.process(obj).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.info('Batch sent for proccessing');
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }
  onPageChange(currentPage: number) {
    this.currentPage = currentPage;
    this.reloadTable(currentPage);
  }
  onVoltageSelect(voltage: string) {
    const utilityId = this.utilitySharedService.getUtilityId();
    if (voltage == '11kV') {
      this.selectedFeeders = this.feeders11;
      this.filteredFeeders = [...this.feeders11];
      if (this.feeders11.length == 0) {
        this.f11Service.getAllForSelect(utilityId).subscribe({
          next: (response: any) => {
            this.feeders11 = response?.body?.data;
            this.selectedFeeders = this.feeders11;
            this.filteredFeeders = [...this.feeders11];
          },
        });
      }
    } else if (voltage == '33kV') {
      this.selectedFeeders = this.feeders33;
      this.filteredFeeders = [...this.feeders33];
      if (this.feeders11.length == 0) {
        this.f33Service.getAllForSelect(utilityId).subscribe({
          next: (response: any) => {
            this.feeders33 = response?.body?.data;
            this.selectedFeeders = this.feeders33;
            this.filteredFeeders = [...this.feeders33];
          },
        });
      }
    }
  }

  filterFeeders() {
    if (!this.searchText.trim()) {
      this.filteredFeeders = [...this.selectedFeeders];
      return;
    }

    const searchTextLower = this.searchText.toLowerCase();
    this.filteredFeeders = this.selectedFeeders.filter((feeder) =>
      feeder.name.toLowerCase().includes(searchTextLower)
    );
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
       if (this.showModal) {
        this.showModal = false;
      }
    }
  }

  closeModal(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (
      target.classList.contains('ai-overlay') || 
      target.classList.contains('close-button')
    ) {
      this.isSelectVoltageOpen = false;
      this.isSelectFeederOpen = false;
      this.showModal = false;
    }
  }

  onFolderSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles = Array.from(input.files);
      this.maxCount = input.files.length;
    }
    this.saveHistory('Processing');
    this.uploadFiles();
    this.showModal = false;
  }

  saveHistory(status: any) {
    this.aiHistoryUploadService.save(this.getSaveObj(status)).subscribe({
      next: (response) => {
        this.reloadTable();
        if (status == 'Completed') {
          this.refreshPageData();
        }
      },
    });
  }
  getSaveObj(status: any) {
    return {
      assetId: this.selectedFeederId,
      assetType: `${this.getAssetType()}`,
      uploadedCount: this.uploadedCount,
      maxCount: this.maxCount,
      url: this.url + '/droneimages/' + this.folderName,
      guid: this.guid,
      uploadStatus: status,
    };
  }
  getAssetType() {
    if (this.selectedVoltage == '33kV') return 'KV33';
    if (this.selectedVoltage == '11kV') return 'KV11';
    return '';
  }

  uploadFiles(): void {
    if (this.selectedFiles.length === 0) return;

    this.uploading = true;
    const batchSize = 10;
    const batches: File[][] = [];
    for (let i = 0; i < this.selectedFiles.length; i += batchSize) {
      batches.push(this.selectedFiles.slice(i, i + batchSize));
    }
    this.processBatches(batches, 0);
  }
  private getSasToken() {
    this.authService.getSas().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sasToken = responseData.data;
          this.folderName = 'CaimsUpload' + Date.now().toString();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private refreshPageData() {
    this.uploading = false;
    this.isSelectFeederOpen = false;
    this.selectedVoltage = '';
    this.isSelectVoltageOpen = false;
    this.selectedFeederId = 0;
    this.maxCount = 0;
    this.uploadedCount = 0;
    this.guid = crypto.randomUUID();
  }

  private processBatches(batches: File[][], index: number): void {
    if (index >= batches.length) {
      this.saveHistory('Completed');
      return;
    }

    const batch = batches[index];
    const uploadObservables: Observable<void>[] = batch.map((file, i) => {
      const fileIndex = index * 10 + i;
      return this.azureBlobService.uploadFile(
        file,
        this.sasToken,
        this.folderName,
        this.url,
        (progress) => {
          this.uploadedCount++;
        }
      );
    });

    forkJoin(uploadObservables).subscribe({
      next: () => {
        this.processBatches(batches, index + 1);
        this.saveHistory('Processing');
      },
      error: (err) => {
        console.error('Batch upload failed:', err);
        this.uploading = false;
      },
    });
  }
}
